import React, { useState } from 'react';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import StyledTooltip from 'Components/UI/StyledTooltip';
import InfoIcon from '@material-ui/icons/Info';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import useManagedAccountPageEventLogger
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/managedAccountPage.eventLogging';

const useStyles = buildUseStyles('ManagedAccountPageInfoStat', (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    whiteSpace: 'nowrap',
  },
  value: {
    marginTop: theme.spacing(0.5),
    fontWeight: theme.typography.fontWeightBold,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  contributionTooltip: {
    color: theme.palette.facet.mediumDarkGray,
    width: 14,
    height: 14,
    marginLeft: theme.spacing(0.5),
  },
}));

const _common = ({
  title, titleExtra, value, hidden, test,
}) => {
  const classes = useStyles();

  if (hidden) return null;

  if (value === '' || value === undefined || value == null) return null;

  return (<>
    <Box className={classes.root} test={test}>
      <Box className={classes.title}>
        <Typography color="mediumDarkGray" variant="body1" weight="bold" test={`${test}--label`}>{title}</Typography>
        {titleExtra ? titleExtra({ classes }) : null}
      </Box>
      <StyledTooltip color="primary" title={value}>
        <Typography className={classes.value} variant="h6" color="primaryGray" test={`${test}--value`}>
          {value}
        </Typography>
      </StyledTooltip>
    </Box>
  </>);
};

const ManagedAccountPageInfoStat = (props) => _common(props);
export default ManagedAccountPageInfoStat;

export const ManagedAccountPageContributionStat = (props) => _common({
  ...props,
  titleExtra: ({ classes }) => (<>
    <StyledTooltip color="primary" title="This number represents IRA contributions that count towards your IRA contribution limit.  This will include contributions to all of your IRAs not just this account.">
      <InfoIcon className={classes.contributionTooltip} />
    </StyledTooltip>
  </>),
});

export const ManagedAccountPageAccountNumberStat = ({
  title, value, hidden, test,
}) => {
  const classes = useStyles();
  const [isValueMasked, setIsValueMasked] = useState(true);
  const { logTopBarEvent } = useManagedAccountPageEventLogger();

  function toggleAccountNumberVisibility() {
    logTopBarEvent(isValueMasked ? 'Show Account Number' : 'Hide Account Number');
    setIsValueMasked(!isValueMasked);
  }

  if (hidden) return null;

  if (value === '' || value === undefined || value == null) return null;

  return (<>
    <Box className={classes.root} test={test}>
      <Box className={classes.title}>
        <Typography color="mediumDarkGray" variant="body1" weight="bold" test={`${test}--label`}>{title}</Typography>
      </Box>
      <Box display="flex" justifyContent="space-between" gap={4}>
        <Typography className={classes.value} variant="h6" color="primaryGray" test={`${test}--value`}>
          {isValueMasked ? `****${value.slice(-4)}` : value}
        </Typography>
        <IconButton size="small" onClick={toggleAccountNumberVisibility} icon={isValueMasked ? Visibility : VisibilityOff} />
      </Box>
    </Box>
  </>);
};
